import * as React from "react";
import { Card, Box } from "@mui/material";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import moment from "moment";
import RouteConstants from "../constants/RouteConstant";
import { useNavigate } from "react-router-dom";

export default function NewBlogCard(props) {
	const navigate = useNavigate();
	return (
		<Card
			sx={{
				width: { xs: 290, md: 380 },
				height: 360,
				gap: 1,
				borderRadius: 4,
				p: 2,
				cursor: "pointer",
			}}
			onClick={() =>
				navigate(RouteConstants.FEED_DETAILS, {
					state: { feed: props.data, index: props.index },
				})
			}
		>
			<CardContent sx={{ height: "100%" }}>
				<Box height={"10%"}>
					<Typography gutterBottom fontWeight={500} fontSize={19}>
						{props.title}
					</Typography>
				</Box>
				<Box height="80%">
					<CardMedia
						// sx={{ height: 286, width: { xs: 285, md: 370 } }}
						sx={{
							height: "100%",
							// width: { xs: 285, md: 370 }
							width: "100%",
							objectFit: "cover",
						}}
						image={props.image}
						title="green iguana"
					/>
				</Box>
				<Box height={"10%"}>
					<Typography fontWeight={400} fontSize={13} sx={{ color: "#667085" }}>
						{moment(props.date).format("MMM Do YYYY") +
							" | By " +
							" " +
							props.author}
					</Typography>
				</Box>
			</CardContent>
		</Card>
	);
}
